const PERSONAL_FILTER_FORM_INITIAL_VALUES = {
  loanAmount: '$15,000',
  creditScoreApprox: 749,
}
const STUDENT_LOAN_REFI_FILTER_FORM_INITIAL_VALUES = {
  loanAmount: '$60,000',
  creditScoreApprox: 749,
}
const DEFAULT_ACTIVE_TAB = 'top-rates'

const YOUNG_ALFRED_STORAGE_KEY = 'young_alfred'

const INSURANCE_FORM_INITIAL_VALUES_FIELDS = [
  'city',
  'country',
  'policyType',
  'state',
  'streetAddress',
  'unit',
  'zipCode',
  'emailAddress',
  'firstName',
  'lastName',
]

export {
  PERSONAL_FILTER_FORM_INITIAL_VALUES,
  STUDENT_LOAN_REFI_FILTER_FORM_INITIAL_VALUES,
  DEFAULT_ACTIVE_TAB,
  YOUNG_ALFRED_STORAGE_KEY,
  INSURANCE_FORM_INITIAL_VALUES_FIELDS,
}
